import { toast } from '@myosh/odin-components';
import { useCallback, useState } from 'react';
import { useDeleteBowtieAndFiltersMutation } from '../api/generated/bowtie-api';

const useDeleteDiagram = (diagramId: string | null) => {
  const [loading, setLoading] = useState(false);
  const [deleteBowtieAndFilters] = useDeleteBowtieAndFiltersMutation();

  const handleDelete = useCallback(async () => {
    if (!diagramId) return;

    setLoading(true);

    const toastId = toast.loading('Deleting the diagram...');

    try {
      const result = await deleteBowtieAndFilters({ id: diagramId }).unwrap();

      if (result) {
        toast.success('Diagram deleted successfully', { id: toastId });

        setTimeout(() => window.location.replace(`${window.location.origin}${window.location.pathname}`), 2000);
      } else if (!result) {
        toast.error('Unable to delete the diagram', { id: toastId });
      }
    } catch {
      toast.error('Unable to delete the diagram', { id: toastId });
    } finally {
      setLoading(false);
    }
  }, [diagramId]);

  return {
    loading,
    handleDelete,
  };
};

export default useDeleteDiagram;
